/**************************************************
 * Nombre:       Tarjeta_Valor_Titulo_Grafica
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {BORDER, SOMBRA, TEXTOCLARO} from "../../ContantesColorGraficas";
import {useObtenerAncho} from "../../Hooks/useObtenerAncho";
import {useRef} from "react";
import {COLORTEXTO} from "../../../Modulo_Tabla_2025/Constantes";

const Tarjeta_Valor_Titulo_Grafica = ({
                                          valor,
                                          titulo,
                                          Grafica,
                                          labels,
                                          series,
                                          height = 'auto',
                                          marginTop = 0,
                                          px = 0,
                                          maxHeight = {xs: 210, sm: 500}
                                      }) => {
    const refe = useRef()
    const {ancho} = useObtenerAncho({contenedor: refe})


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={12}
            sx={{
                backgroundColor: '#fff',
                borderRadius: 2,
                border: BORDER,
                boxShadow: SOMBRA,
                p: 2,
                maxHeight: maxHeight,
            }}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>
                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography sx={{color: COLORTEXTO, fontWeight: 700, fontSize: 18}}>{valor}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography sx={{color: TEXTOCLARO, fontSize: 14, fontWeight: 500}}>{titulo}</Typography>
                    </Grid>

                    <Grid ref={refe} container size={{xs: 12, sm: 12, md: 12}}
                          sx={{
                              px: px,
                              py: 2,
                              justifyContent: 'center',
                              height: height,
                              alignItems: 'flex-end',
                              marginTop: marginTop,
                              maxWidth: '100%'
                          }}>
                        <Grafica ancho={ancho} labels={labels} series={series} height={height} marginTop={marginTop}/>
                    </Grid>


                </Grid>
            </Grid>



        </Grid>
    )

}
export default Tarjeta_Valor_Titulo_Grafica